<template>
  <div v-loading="loading">
    <el-alert
      type="info"
      :closable="false"
      show-icon
      title="开启后，新用户注册、套餐在线支付成功、对公转账认款提交、咨询工单提交时，会发邮件给下面的客服邮箱。多个邮箱用逗号分隔。"
      style="margin-bottom: 16px"
    />
    <el-form :model="form" label-width="110px" style="max-width: 720px">
      <el-form-item label="启用通知">
        <el-switch v-model="form.enabled" />
      </el-form-item>
      <el-form-item label="发信服务器" required>
        <el-input v-model="form.smtpHost" placeholder="如 smtp.exmail.qq.com" maxlength="128" />
      </el-form-item>
      <el-form-item label="端口" required>
        <el-input-number v-model="form.smtpPort" :min="1" :max="65535" :controls="false" />
      </el-form-item>
      <el-form-item label="加密连接">
        <el-switch v-model="form.sslEnabled" />
        <span class="hint">开启为 SSL，端口一般是 465；关闭为 STARTTLS，端口一般是 587</span>
      </el-form-item>
      <el-form-item label="发信账号" required>
        <el-input v-model="form.username" placeholder="发信邮箱账号" maxlength="128" />
      </el-form-item>
      <el-form-item label="发信密码" required>
        <el-input
          v-model="form.password"
          type="password"
          show-password
          :placeholder="form.passwordSet ? '已保存，留空则不修改' : '邮箱密码或授权码'"
          maxlength="128"
        />
      </el-form-item>
      <el-form-item label="发件人名称">
        <el-input v-model="form.fromName" placeholder="华锐智造云" maxlength="64" />
      </el-form-item>
      <el-form-item label="客服邮箱" required>
        <el-input
          v-model="form.notifyEmails"
          type="textarea"
          :rows="3"
          placeholder="多个邮箱用逗号分隔，例如 a@example.com,b@example.com"
          maxlength="1000"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
        <el-button :loading="testing" @click="testSend">发送测试邮件</el-button>
        <el-button @click="load">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getOpsMailConfig, saveOpsMailConfig, testOpsMail } from '../../api/sys'

export default {
  name: 'OpsMail',
  data() {
    return {
      loading: false,
      saving: false,
      testing: false,
      form: {
        enabled: false,
        smtpHost: '',
        smtpPort: 465,
        sslEnabled: true,
        username: '',
        password: '',
        passwordSet: false,
        fromName: '华锐智造云',
        notifyEmails: ''
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await getOpsMailConfig()
        const data = res.data || {}
        this.form = {
          enabled: !!data.enabled,
          smtpHost: data.smtpHost || '',
          smtpPort: data.smtpPort || 465,
          sslEnabled: data.sslEnabled !== false,
          username: data.username || '',
          password: '',
          passwordSet: !!data.passwordSet,
          fromName: data.fromName || '华锐智造云',
          notifyEmails: data.notifyEmails || ''
        }
      } finally {
        this.loading = false
      }
    },
    payload() {
      return {
        enabled: this.form.enabled,
        smtpHost: this.form.smtpHost,
        smtpPort: this.form.smtpPort,
        sslEnabled: this.form.sslEnabled,
        username: this.form.username,
        password: this.form.password,
        fromName: this.form.fromName,
        notifyEmails: this.form.notifyEmails
      }
    },
    async save() {
      this.saving = true
      try {
        await saveOpsMailConfig(this.payload())
        this.$message.success('已保存')
        this.load()
      } finally {
        this.saving = false
      }
    },
    async testSend() {
      this.testing = true
      try {
        await testOpsMail(this.payload())
        this.$message.success('测试邮件已发送')
      } finally {
        this.testing = false
      }
    }
  }
}
</script>

<style scoped>
.hint { margin-left: 12px; color: #94a3b8; font-size: 12px; }
</style>
